import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../../scrollbar.css';
import { useStateValue } from '../../ContextApi/StateProvider';

function SideMenu() {
  const history = useHistory();
  const location = useLocation();
  const [{ user }, dispatch] = useStateValue();

  const getNameInitials = (name) => {
    if (!name) return '';
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  };

  return (
    <div className=" fixed flex flex-col w-sidebar bg-sideColor h-full pt-5" style={{ background: '#F4F6F8' }}>
      <div className={`${location.pathname === '/organization' && 'text-activeIcon'
        } cursor-pointer`}
        onClick={() => history.push('/organization')}>
        <img src="assets/img/NewLogo.svg" alt="" className="max-w-full imgSize " />
      </div>

      <div className="w-max">
        <div
          className={`${location.pathname === '/dashboard' && 'text-activeIcon'
            } block md:flex  items-center h-12 px-2 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/dashboard')}
        >
          <img
            src={location.pathname === '/dashboard' ? 'assets/img/DashbordIcon.png' : 'assets/img/Dashboard_White.png'}
            alt=""
            className="h-7 mr-2"
          />
          {location.pathname === '/dashboard' ? (
            <p className="text-textBlue1 textSize hidden md:block">Dashboard</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block">Dashboard</p>
          )}
        </div>
        <div
          className={`${location.pathname === '/zone' && 'text-activeIcon'
            } block md:flex  items-center h-12 px-3 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/zone')}
        >
          <img
            src={location.pathname === '/zone' ? 'assets/img/Zones_Active.svg' : 'assets/img/Zones_Inactive.svg'}
            alt=""
            className="h-7 mr-2"
          />
          {location.pathname === '/zone' ? (
            <p className="text-textBlue1 textSize hidden md:block px-1">Zones</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block px-1">Zones</p>
          )}
        </div>
        <div
          className={`${location.pathname === '/projects' && 'text-activeIcon'
            } block md:flex  items-center h-12 px-2 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/projects')}
        // style={{ paddingLeft: '0px' }}
        >
          <img
            src={location.pathname === '/projects' ? 'assets/img/Project_Green.png' : 'assets/img/Project_White.png'}
            alt=""
            className="h-7 mr-2"
          />
          {location.pathname === '/projects' ? (
            <p className="text-textBlue1 textSize hidden md:block">Project</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block">Project</p>
          )}
        </div>

        <div
          className={`${location.pathname === '/users' && 'text-activeIcon'
            } block md:flex  items-center h-12 px-2 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/users')}
        // style={{ paddingLeft: '0px' }}
        >
          <img
            src={location.pathname === '/users' ? 'assets/img/Add User_Green.png' : 'assets/img/Add User_White.png'}
            alt=""
            className="text-icon h-7 mr-2"
          />
          {location.pathname === '/users' ? (
            <p className="text-textBlue1 textSize hidden md:block">Users</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block">Users</p>
          )}
        </div>

        <div
          className={`${location.pathname === '/inventory' && 'text-activeIcon'
            } block md:flex  items-center h-12 px-2 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/inventory')}
        // style={{ paddingLeft: '0px' }}
        >
          <img
            src={
              location.pathname === '/inventory'
                ? 'assets/img/Inventory_Green.png'
                : 'assets/img/Inventory Mgmg_White.png'
            }
            alt=""
            className="text-icon h-7 mr-2"
          />
          {location.pathname === '/inventory' ? (
            <p className="text-textBlue1 textSize hidden md:block">Devices</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block">Devices</p>
          )}
        </div>

        <div
          className={`${location.pathname === '/webhooks' && 'text-activeIcon'
            } block md:flex items-center h-12 px-2 md:mx-4 cursor-pointer`}
          onClick={() => history.push('/webhooks')}
        >
          <img
            src={location.pathname === '/webhooks' ? 'assets/img/webhook-white.png' : 'assets/img/webhook-green.png'}
            alt=""
            className="text-icon h-7 mr-2"
          />
          {location.pathname === '/webhooks' ? (
            <p className="text-textBlue1 textSize hidden md:block">Webhooks</p>
          ) : (
            <p className="text-textBoldBlack textSize text-sm hidden md:block">Webhooks</p>
          )}
        </div>
      </div>

      <div className="logout  rounded-md">
        <div
          className={`mr-2 h-6 md:h-14 w-6 md:w-14 flex justify-center items-center rounded-full ${!user?.avatar && 'bg-primary'
            } userInfo cursor-pointer`}
          onClick={() => history.push('/account')}
        >
          {user?.avatar ? (
            <img src={user?.avatar + '?' + global.Date.now()} className="h-full w-full rounded-full" />
          ) : (
            <span className="text-base">{getNameInitials(user?.userName)}</span>
          )}
        </div>
        <div className="flex flex-col items-center w-full">
          <span
            className="text-base font-bold x hidden md:block cursor-pointer"
            onClick={() => history.push('/account')}
          >
            {user?.userName}
          </span>
          <button
            type="submit"
            className="logoutBtn font-bold px-0 md:px-6 py-0 md:py-2"
            onClick={() => {
              localStorage.clear();
              history.replace('/');
              dispatch({
                type: 'USER_DATA',
                user: null,
              });
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default SideMenu;
